import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { ResetPasswordRoute } from "../../Components/ResetPasswordRoute";

export const Route = createFileRoute("/_accountLayout/reset-password")({
	component: RouteComponent,
});

function RouteComponent() {
	const navigate = useNavigate();
	return (
		<ResetPasswordRoute
			onSuccess={async (prefillUsername) => {
				// Add a small delay to ensure login state is properly set
				await new Promise((resolve) => setTimeout(resolve, 100));
				try {
					await navigate({
						to: "/login",
						replace: true,
						search: { prefillUsername },
					});
				} catch (_error) {
					// Fallback: force page reload if navigation fails
					window.location.href = "/login";
				}
			}}
		/>
	);
}
